import { IActionWithPayload } from "store/helper";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import {
  IPartialInvitePayload,
  WelcomeTutorialViewAction,
  WelcomeTutorialViewActionsNames,
} from "store/views/welcome-tutorial";

export interface IWelcomeTutorialViewState {
  partialInvite: IPartialInvitePayload;
  keepWelcomeTutorialOpened: boolean;
}

export const initialState: IWelcomeTutorialViewState = {
  partialInvite: {
    successfulAgents: [],
    failedAgents: [],
    exceededBy: 0,
  },
  keepWelcomeTutorialOpened: false,
};

export const welcomeTutorialViewReducer = (
  state: IWelcomeTutorialViewState = initialState,
  action: WelcomeTutorialViewAction
): IWelcomeTutorialViewState => {
  switch (action.type) {
    case WelcomeTutorialViewActionsNames.INVITE_AGENTS_PARTIAL_SUCCESS: {
      return {
        ...state,
        partialInvite: (action as IActionWithPayload<string, IPartialInvitePayload>).payload,
      };
    }
    case WelcomeTutorialViewActionsNames.KEEP_TUTORIAL_OPENED: {
      return {
        ...state,
        keepWelcomeTutorialOpened: (action as IActionWithPayload<string, boolean>).payload,
      };
    }

    default:
      return state;
  }
};
